import { render, staticRenderFns } from "./CreateCampaignSetupsAudience.vue?vue&type=template&id=62730690&scoped=true"
import script from "./CreateCampaignSetupsAudience.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62730690",
  null
  
)

export default component.exports